<template>
  <div :class="containerClass" @click="onWrapperClick">
    <UpdateNotification />
    <AppTopBar @menu-toggle="onMenuToggle" />
    <div class="layout-sidebar" @click="onSidebarClick">
      <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
      <PanelMenu :model="panelMenuitems" />
    </div>

    <div class="layout-main-container">
      <div class="layout-main">
        <router-view />
      </div>
      <AppFooter />
    </div>
    <AppConfig :layoutMode="layoutMode" @layout-change="onLayoutChange" />
    <transition name="layout-mask">
      <div
        class="layout-mask p-component-overlay"
        v-if="mobileMenuActive"
      ></div>
    </transition>
  </div>
</template>

<script>
import AppTopBar from "./AppTopbar.vue";
import AppMenu from "./AppMenu.vue";
import AppConfig from "./AppConfig.vue";
import AppFooter from "./AppFooter.vue";
import { useAuth } from "./stores";
import UpdateNotification from "@/components/UpdateNotification.vue";

export default {
  emits: ["change-theme"],
  data() {
    return {
      layoutMode: "static",
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      menu: [
        {
          label: "MENÚ PRINCIPAL",
          items: [{ label: "INICIO", icon: "pi pi-fw pi-home", to: "/" }],
        },
      ],
      panelMenuitems: [],
    };
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    },
  },
  authService: null,
  created() {
    this.authService = useAuth();
  },
  mounted() {
    let permisosUsuarioAuth = this.authService.user.permissions;

    let permisosAsignados = [];
    //PARAMETROS - Modulo
    //Productos - Menu

    // Submenus
    let menu = [];

    let submenusItems = [];

    if (
      /*  "Laboratorio Listar" && */
      "Laboratorio Crear" in
      /*  "Laboratorio Editar" &&
      "Laboratorio Ver Detalle" &&
      "Laboratorio Eliminar" */ permisosUsuarioAuth
    ) {
      submenusItems.push({
        label: "Grupos",
        icon: "pi pi-briefcase",
        to: "/laboratorios",
      });
    }
    if (
      "Unidad de Medida Crear" /* &&
      "Unidad de Medida Editar" &&
      "Unidad de Medida Eliminar" &&
      "Unidad de Medida Importar" &&
      "Unidad de Medida Exportar" */ in permisosUsuarioAuth
    ) {
      submenusItems.push({
        label: "Unidad de Medidas",
        icon: "pi pi-tag",
        to: "/unidadmedidas",
      });
    }

    if (
      "PaqueteProducto Crear" /* &&
      "PaqueteProducto Editar" &&
      "PaqueteProducto Ver Detalle" &&
      "PaqueteProducto Eliminar" &&
      "PaqueteProducto AgregarProducto" */ in permisosUsuarioAuth
    ) {
      submenusItems.push({
        label: "Paquetes de Productos",
        icon: "pi pi-box",
        to: "/paqueteproductos",
      });
    }
    if (
      "Producto Crear" /* &&
      "Producto Editar" &&
      "Producto Ver Detalle" &&
      "Producto Eliminar" */ in permisosUsuarioAuth
    ) {
      submenusItems.push({
        label: "Administrar Productos",
        icon: "pi pi-list",
        to: "/productos",
      });
    }

    //Productos - Menu

    if (submenusItems.length) {
      menu.push({
        label: "Productos",
        icon: "pi pi-fw pi-box",
        items: submenusItems,
      });
    }

    if (menu.length) {
      permisosAsignados.push({
        label: "PARAMETROS",
        icon: "pi pi-fw pi-table",
        items: menu,
      });
    }

    //FIN MODULO PARAMETROS

    //MODULO DE COMPRAS
    menu = [];
    submenusItems = [];

    if ("Proveedor Realizar Pagos" in permisosUsuarioAuth) {
      submenusItems.push({
        label: "Pago Proveedores",
        icon: "pi pi-money-bill",
        to: "/proveedorpagos",
      });
    }
    if (
      "Proveedor Crear" /* &&
      "Proveedor Editar" &&
      "Proveedor Ver Detalle" &&
      "Proveedor Eliminar" */ in permisosUsuarioAuth
    ) {
      submenusItems.push({
        label: "Listado Proveedores",
        icon: "pi pi-list",
        to: "/proveedores",
      });
    }
    if (
      "Compra Crear" in
      /* "Compra Ver Detalle" &&
      "Compra Recibir" &&
      "Compra DescargarPDF" &&
      "Compra Ver DetalleRecepcion" &&
      "Compra Anular"  */ permisosUsuarioAuth
    ) {
      menu.push({
        label: "Listado Compras",
        icon: "pi pi-fw pi-list",
        to: "/compras",
      });
    }

    if (submenusItems.length) {
      menu.push({
        label: "Proveedores",
        icon: "pi pi-fw pi-user-plus",
        items: submenusItems,
      });
    }

    if (menu.length) {
      permisosAsignados.push({
        label: "COMPRAS",
        icon: "pi pi-shopping-bag",
        items: menu,
      });
    }
    //FIN MÓDULO DE COMPRAS

    //MODULO DE CAJA

    menu = [];

    if (
      "Caja Crear" /*  ||
      "Caja Cerrar" ||
      "Caja Ver Detalle" ||
      "Caja Eliminar" ||
      "Caja DescargarPDF" */ in permisosUsuarioAuth
    ) {
      menu.push({
        label: "Listado Cajas",
        icon: "pi pi-fw pi-list",
        to: "/caja",
      });
    }
    if ("PagoQr Crear" in permisosUsuarioAuth) {
      menu.push({
        label: "Pagos Qr",
        icon: "pi pi-fw pi-qrcode",
        to: "/pagosqr",
      });
    }
    if (menu.length) {
      permisosAsignados.push({
        label: "CAJA",
        icon: "pi pi-wallet",
        items: menu,
      });
    }
    //FIN MÓDULO DE CAJAS

    //MODULO DE HISTORIAS CLINICAS

    menu = [];

    /* if ("Historias Listar" in permisosUsuarioAuth) {
      menu.push({
        label: "Listado Historias Clinicas",
        icon: "pi pi-fw pi-list",
        to: "/historias",
      });
    } */
    if ("Historias Crear" in permisosUsuarioAuth) {
      menu.push({
        label: "Ver Fichas Consultas",
        icon: "pi pi-fw pi-list",
        to: "/fichas_consultas",
      });
    }
    if ("R_Historia Listar" in permisosUsuarioAuth) {
      menu.push({
        label: "Informe Sedes",
        icon: "pi pi-fw pi-list",
        to: "/info_sedes",
      });
    }
    /* if ("FrmPredefinido Crear" in permisosUsuarioAuth) {
      menu.push({
        label: "Formularios Predefinidos",
        icon: "pi pi-fw pi-file",
        to: "/frmpredefinidos",
      });
    } */

    if (menu.length) {
      permisosAsignados.push({
        label: "HISTORIAS CLINICAS",
        icon: "pi pi-fw pi-list",
        items: menu,
      });
    }

    //FIN MÓDULO ODONTOLOGIA

    menu = [];
    if ("Agenda Crear" in permisosUsuarioAuth) {
      menu.push({
        label: "Agenda Odontologica",
        icon: "pi pi-calendar-plus",
        to: "/agendas",
      });
    }
    if ("PlanTratamiento Crear" in permisosUsuarioAuth) {
      menu.push({
        label: "Datos Personales de Paciente",
        icon: "pi pi-id-card",
        to: "/plantratamientos",
      });
    }
    if ("Agenda Reportes" in permisosUsuarioAuth) {
      menu.push({
        label: "Reporte de Agenda",
        icon: "pi pi-fw pi-list",
        to: "/reportes_agendas",
      });
    }

    if ("FrmPredefinido Crear" in permisosUsuarioAuth) {
      menu.push({
        label: "Formularios Predefinidos",
        icon: "pi pi-fw pi-file",
        to: "/frmpredefinidos",
      });
    }
    if ("Consultorio Crear" in permisosUsuarioAuth) {
      menu.push({
        label: "Consultorios",
        icon: "pi pi-fw pi-list",
        to: "/consultorio",
      });
    }
    if ("WhatsApp Crear" in permisosUsuarioAuth) {
      menu.push({
        label: "Configuración de WhatsApp",
        icon: "pi pi-fw pi-whatsapp",
        to: "/whatsapp",
      });
    }

    if (menu.length) {
      permisosAsignados.push({
        label: "ODONTOLOGIA",
        icon: "pi pi-tablet",
        items: menu,
      });
    }
    //FIN MÓDULO DE CAJAS

    // MODULO VENTAS

    menu = [];
    //submenusItems = [];

    if ("Venta Crear" in permisosUsuarioAuth) {
      menu.push({
        label: "Nueva Venta",
        icon: "pi pi-fw pi-plus-circle",
        to: "/nueva_venta",
      });
    }

    if (
      "Venta Listar" &&
      "Venta Crear" &&
      "Venta Ver Detalle" &&
      "Venta DescargarPDF" in permisosUsuarioAuth
    ) {
      menu.push({
        label: "Listado de Ventas",
        icon: "pi pi-fw pi-list",
        to: "/ventas",
      });
    }

    if ("Venta Facturar" in permisosUsuarioAuth) {
      menu.push({
        label: "Clientes Facturados",
        icon: "pi pi-fw pi-users",
        to: "/clientes_facturas",
      });
    }
    if ("Cliente Crear" in permisosUsuarioAuth) {
      menu.push({
        label: "Listado de Pacientes",
        icon: "pi pi-fw pi-users",
        to: "/clientes",
      });
    }
    if ("Cliente Pagos" in permisosUsuarioAuth) {
      menu.push({
        label: "Deudas / Cuentas por Cobrar",
        icon: "pi pi-money-bill",
        to: "/clientespagos",
      });
    }

    /* if (submenusItems.length) {
      menu.push({
        label: "Clientes",
        icon: "pi pi-fw pi-user-plus",
        items: submenusItems,
      });
    } */

    if ("Comisiones Crear" in permisosUsuarioAuth) {
      menu.push({
        label: "Comisiones",
        icon: "pi pi-fw pi-wallet",
        to: "/comisiones",
      });
    }

    if (menu.length) {
      permisosAsignados.push({
        label: "VENTAS/SERVICIOS",
        icon: "pi pi-inbox",
        items: menu,
      });
    }
    // FIN MODULO VENTAS

    // MODULO GESTION DE CALIDAD

    menu = [];
    submenusItems = [];

    if ("Paciente Crear" in permisosUsuarioAuth) {
      menu.push({
        label: "Listado de Pacientes",
        icon: "pi pi-users",
        to: "/pacientes",
      });
    }

    if ("R_Cumpleanos Listar" in permisosUsuarioAuth) {
      menu.push({
        label: "Cumpleañeros",
        icon: "pi pi-star-fill",
        to: "/clientes_cumpleanos",
      });
    }
    if ("SeguimientoCalidad Crear" in permisosUsuarioAuth) {
      menu.push({
        label: "Listado de Seguimiento",
        icon: "pi pi-calendar-plus",
        to: "/seguimientos",
      });
    }
    if (menu.length && "GestionCalidad Listar" in permisosUsuarioAuth) {
      permisosAsignados.push({
        label: "GESTION DE CALIDAD",
        icon: "pi pi-shield",
        items: menu,
      });
    }

    // MODULO FACTURACION

    menu = [];
    submenusItems = [];

    if (
      "PuntoVenta Crear" &&
      "PuntoVenta Editar" &&
      "PuntoVenta Eliminar" in permisosUsuarioAuth
    ) {
      menu.push({
        label: "Puntos de Venta",
        icon: "pi pi-fw pi-shopping-cart",
        to: "/punto_venta",
      });
    }

    if (
      "Dosificacion Crear" &&
      "Dosificacion Editar" &&
      "Dosificacion Eliminar" in permisosUsuarioAuth
    ) {
      menu.push({
        label: "Dosificaciones",
        icon: "pi pi-fw pi-file",
        to: "/dosificaciones",
      });
    }
    if ("R_Facturacion Listar" in permisosUsuarioAuth) {
      menu.push({
        label: "Facturas Emitidas",
        icon: "pi pi-file",
        to: "/filtros_facturas",
      });
    }

    if ("R_Facturacion Listar" in permisosUsuarioAuth) {
      menu.push({
        label: "Facturas Electrónicas Emitidas",
        icon: "pi pi-file",
        to: "/filtros_facturas_electronicas",
      });
    }

    if (menu.length) {
      permisosAsignados.push({
        label: "FACTURACION",
        icon: "pi pi-fw pi-file",
        items: menu,
      });
    }

    // FIN MODULO FACTURACION

    //MODULO DE REPORTES

    menu = [];
    submenusItems = [];

    if ("R_Productos de Productos" in permisosUsuarioAuth) {
      submenusItems.push({
        label: "Reporte de Productos",
        icon: "pi pi-box",
        to: "/reportes/productos",
      });
    }
    if ("R_FechaVence de FechaVence" in permisosUsuarioAuth) {
      submenusItems.push({
        label: "Fecha Vence Productos",
        icon: "pi pi-calendar",
        to: "/fechavence",
      });
    }
    if (submenusItems.length) {
      menu.push({
        label: "Reporte de Productos",
        icon: "pi pi-inbox",
        items: submenusItems,
      });
    }
    submenusItems = [];

    if ("R_Ventas de Ventas" in permisosUsuarioAuth) {
      submenusItems.push({
        label: "Reporte General Ventas",
        icon: "pi pi-inbox",
        to: "/reportes/ventas",
      });
    }
    if ("R_Ganancias de Ganancias" in permisosUsuarioAuth) {
      submenusItems.push({
        label: "Informe Ganancias",
        icon: "pi pi-inbox",
        to: "/reportes/ventas/ganancias",
      });
    }

    if (submenusItems.length) {
      menu.push({
        label: "Reporte de Ventas",
        icon: "pi pi-inbox",
        items: submenusItems,
      });
    }

    if ("R_Compras de Compras" in permisosUsuarioAuth) {
      menu.push({
        label: "Reporte de Compras",
        icon: "pi pi-shopping-bag",
        to: "/reportes/compras",
      });
    }
    if ("R_Inversion de Inversion" in permisosUsuarioAuth) {
      menu.push({
        label: "Inversión en Negocio",
        icon: "pi pi-money-bill",
        to: "/reportes/inversionnegocio",
      });
    }

    if ("R_Stock de Stock" in permisosUsuarioAuth) {
      menu.push({
        label: "Reporte de Stock",
        icon: "pi pi-box",
        to: "/reportes/stocks",
      });
    }
    if ("R_Stock de StockGeneral" in permisosUsuarioAuth) {
      menu.push({
        //le pongo con negrita y fondo verde para que se vea mejor
        style: "font-weight: bold;",
        label: "Reporte de Stock General",
        icon: "pi pi-box",
        to: "/reportes/stoksgeneral",
      });
    }

    if ("R_Clientes de Clientes" in permisosUsuarioAuth) {
      menu.push({
        label: "Reporte de Clientes/Ventas",
        icon: "pi pi-users",
        to: "/reportes/clientes",
      });
    }
    if ("R_Cajas de Cajas" in permisosUsuarioAuth) {
      menu.push({
        label: "Reporte de Cajas",
        icon: "pi pi-wallet",
        to: "/reportes/cajas",
      });
    }

    if (menu.length) {
      permisosAsignados.push({
        label: "REPORTES",
        icon: "pi pi-fw pi-chart-bar",
        items: menu,
      });
    }
    //FIN MÓDULO DE REPORTES

    //MODULO DE Inventario
    menu = [];
    submenusItems = [];
    if ("Inventario ImportarStockInicial" in permisosUsuarioAuth) {
      menu.push({
        label: "Carga Inicial",
        icon: "pi pi-fw pi-upload",
        to: "/inventario/carga_inicial",
      });
    }
    if ("Inventario Movimientos" in permisosUsuarioAuth) {
      submenusItems.push({
        label: "Ingreso/Egreso",
        icon: "pi pi-list",
        to: "/movimientos",
      });
    }
    if ("Inventario Movimientos" in permisosUsuarioAuth) {
      submenusItems.push({
        label: "Listado de Movimientos",
        icon: "pi pi-print",
        to: "/MovAlmacenList",
      });
    }

    if (submenusItems.length) {
      menu.push({
        label: "Movimientos",
        icon: "pi pi-sync",
        items: submenusItems,
      });
    }

    if ("Inventario KardexProductos" in permisosUsuarioAuth) {
      menu.push({
        label: "Kardex de Productos",
        icon: "pi pi-box",
        to: "/kardex",
      });
    }
    if ("Inventario Traspasos" in permisosUsuarioAuth) {
      menu.push({
        label: "Traspaso de Productos",
        icon: "pi pi-arrows-h",
        to: "/traspasos",
      });
    }

    if (menu.length) {
      permisosAsignados.push({
        label: "INVENTARIO/KARDEX",
        icon: "pi pi-fw pi-box",
        items: menu,
      });
    }

    //Fin MODULO DE Inventario

    //MODULO DE CONFIGURACIONES
    menu = [];

    if (
      "Sucursal Editar" /* &&
      "Sucursal Empresa" &&
      "Sucursal Editar" &&
      "Sucursal Ver Detalle" &&
      "Sucursal Eliminar" */ in permisosUsuarioAuth
    ) {
      menu.push({
        label: "Empresa",
        icon: "pi pi-fw pi-building",
        to: "/configuracion/empresa",
      });

      menu.push({
        label: "Sucursales",
        icon: "pi pi-fw pi-building",
        to: "/sucursales",
      });
    }
    if (
      "Usuario Crear" &&
      "Usuario Editar" &&
      "Usuario Eliminar" &&
      "Usuario Ver Detalle" in permisosUsuarioAuth
    ) {
      menu.push({
        label: "Usuarios",
        icon: "pi pi-users",
        to: "/users",
      });
    }
    if ("Bitacoras Listar" in permisosUsuarioAuth) {
      menu.push({
        label: "Responables",
        icon: "pi pi-users",
        to: "responsables/listado",
      });
    }

    if (
      "Medico Crear" &&
      "Medico Editar" &&
      "Medico Eliminar" in permisosUsuarioAuth
    ) {
      menu.push({
        label: "Medicos",
        icon: "pi pi-id-card",
        to: "/medicos",
      });
    }
    if ("Rol Listar" in permisosUsuarioAuth) {
      menu.push({
        label: "Roles",
        icon: "pi pi-tags",
        to: "/roles",
      });
    }

    if ("Bitacoras Listar" in permisosUsuarioAuth) {
      menu.push({
        label: "Bitacora",
        icon: "pi pi-sync",
        to: "/bitacoras",
      });
    }

    if (menu.length) {
      permisosAsignados.push({
        label: "CONFIGURACIONES",
        icon: "pi pi-fw pi pi-fw pi-cog",
        items: menu,
      });
    }

    //FIN MÓDULO DE CONFIGURACIONES

    this.panelMenuitems = permisosAsignados;
  },
  methods: {
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }

          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    onLayoutChange(layoutMode) {
      this.layoutMode = layoutMode;
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth >= 992;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === "static") return !this.staticMenuInactive;
        else if (this.layoutMode === "overlay") return this.overlayMenuActive;
      }

      return true;
    },
  },
  computed: {
    containerClass() {
      return [
        "layout-wrapper",
        {
          "layout-overlay": this.layoutMode === "overlay",
          "layout-static": this.layoutMode === "static",
          "layout-static-sidebar-inactive":
            this.staticMenuInactive && this.layoutMode === "static",
          "layout-overlay-sidebar-active":
            this.overlayMenuActive && this.layoutMode === "overlay",
          "layout-mobile-sidebar-active": this.mobileMenuActive,
          "p-input-filled": this.$primevue.config.inputStyle === "filled",
          "p-ripple-disabled": this.$primevue.config.ripple === false,
        },
      ];
    },
    logo() {
      return this.$appState.darkTheme
        ? "images/logo-white.svg"
        : "images/logo.svg";
    },
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, "body-overflow-hidden");
    else this.removeClass(document.body, "body-overflow-hidden");
  },
  components: {
    AppTopBar: AppTopBar,
    AppMenu: AppMenu,
    AppConfig: AppConfig,
    AppFooter: AppFooter,
    UpdateNotification: UpdateNotification,
  },
};
</script>

<style lang="scss">
@import "./App.scss";
.p-panelmenu {
  .p-panelmenu-header {
    // Icono del header principal
    .p-panelmenu-icon {
      color: #2196f3; // Azul vibrante de Saga Blue
      font-size: 1.1rem;
      transition: all 0.3s ease;
    }

    // Hover en el header
    &:not(.p-disabled):hover {
      .p-panelmenu-icon {
        color: #1976d2; // Azul más oscuro en hover
        transform: scale(1.1);
      }
    }
  }

  // Contenido del panel
  .p-panelmenu-content {
    // Items del menú
    .p-menuitem-link {
      transition: all 0.3s ease;

      .p-menuitem-icon {
        color: #2196f3;
        font-size: 1rem;
        margin-right: 0.75rem;
        transition: all 0.3s ease;
      }

      .p-menuitem-text {
        font-weight: 500;
        transition: color 0.3s ease;
      }

      // Hover en items
      &:not(.p-disabled):hover {
        background: rgba(33, 150, 243, 0.1);

        .p-menuitem-icon {
          color: #1976d2;
          transform: translateX(3px) scale(1.05);
        }

        .p-menuitem-text {
          color: #1976d2;
        }
      }

      // Item activo (router-link-active)
      &.router-link-active {
        background: rgba(33, 150, 243, 0.15);
        border-left: 3px solid #2196f3;

        .p-menuitem-icon {
          color: #1976d2;
          font-weight: bold;
        }

        .p-menuitem-text {
          color: #1976d2;
          font-weight: 600;
        }
      }
    }
  }
}

// Estilos para el AppMenu (si usas el menú lateral estándar)
.layout-sidebar {
  .layout-menu {
    .layout-menuitem-root-text {
      color: #546e7a; // Gris azulado para labels
      font-weight: 600;
      font-size: 0.875rem;
      letter-spacing: 0.5px;
    }

    .layout-menuitem {
      .layout-menuitem-content {
        .p-ripple {
          transition: all 0.3s ease;

          .layout-menuitem-icon {
            color: #2196f3;
            font-size: 1.125rem;
            margin-right: 0.75rem;
            transition: all 0.3s ease;
          }

          .layout-menuitem-text {
            color: #495057;
            font-weight: 500;
            transition: color 0.3s ease;
          }

          &:hover {
            background: linear-gradient(
              90deg,
              rgba(33, 150, 243, 0.08) 0%,
              transparent 100%
            );

            .layout-menuitem-icon {
              color: #1976d2;
              transform: scale(1.1);
            }

            .layout-menuitem-text {
              color: #1976d2;
            }
          }

          // Estado activo
          &.active-menuitem {
            background: linear-gradient(
              90deg,
              rgba(33, 150, 243, 0.15) 0%,
              transparent 100%
            );
            border-left: 4px solid #2196f3;
            box-shadow: 0 2px 4px rgba(33, 150, 243, 0.1);

            .layout-menuitem-icon {
              color: #1976d2;
              font-weight: bold;
              animation: pulse 2s ease-in-out infinite;
            }

            .layout-menuitem-text {
              color: #1976d2;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}

// Animación sutil para iconos activos
@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

// Efecto de brillo para iconos importantes
.p-menuitem-icon.highlight {
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: -2px;
    right: -2px;
    width: 8px;
    height: 8px;
    background: #ff5722; // Color de acento para notificaciones
    border-radius: 50%;
    box-shadow: 0 0 6px rgba(255, 87, 34, 0.6);
  }
}

// Responsive: iconos más grandes en móvil
@media screen and (max-width: 991px) {
  .p-menuitem-icon,
  .layout-menuitem-icon {
    font-size: 1.25rem !important;
  }
}
</style>